import React, {Component} from 'react';
import {FuseAnimate} from '@fuse';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom'
import {bindActionCreators} from 'redux';
import Widget1 from './widgets/Widget1';
// import Widget2 from './widgets/Widget2';
// import Widget3 from './widgets/Widget3';
// import Widget4 from './widgets/Widget4';
// import Widget5 from './widgets/Widget5';
// import Widget6 from './widgets/Widget6';
// import Widget7 from './widgets/Widget7';
// import Widget8 from './widgets/Widget8';
import RankingWidget from './widgets/RankingWidget';
// import withReducer from 'app/store/withReducer';
import * as Actions from './store/actions'

import fakeDB from '../../../constants/dashboardConstants';

const widgetDecorator = ({array, widget, type}) => {
    switch(type) {
        case 'monthly':
            for (let key in widget['datasets']) {
                if (widget['datasets'].hasOwnProperty(key)) widget['datasets'][key] = [{
                    label: 'Sales',
                    data: array,
                    fill: 'start'
                }];
            }
            break;
        case 'vipRanking':
            widget.rows = array.map(ele => {
                return {
                    title: ele.name,
                    column1: ele.total,
                    column2: ele.count,
                };
            });
            break;
        case 'medicalRanking':
            widget.rows = array.map(ele => {
                return {
                    title: ele.name,
                    column1: ele.total,
                    column2: ele.count,
                };
            });
            break;
        default:
            return widget;
    }
};


class AnalyticsDashboardApp extends Component {

    componentDidMount()
    {
        this.props.getMonthlyData(); //抓同年度的資料
        this.props.getRankingData(); //抓排行榜的資料
    }

    render()
    {
        const widgets = fakeDB.widgets;
        const {monthlyData, rankingData} = this.props;
        if ( !widgets || !monthlyData || !rankingData)
        {
            return (<div>無法載入資料</div>);
        }

        return (
            <div className="w-full">

                <Widget1 data={widgetDecorator({widget: widgets.monthlyWidget, type: 'monthly', array: monthlyData.data})}/>

                <FuseAnimate animation="transition.slideUpIn" delay={200}>

                    <div className="flex flex-col md:flex-row sm:p-8 container">

                        <div className="flex flex-col sm:flex sm:flex-row pb-32">

                            <div className="mb-32 w-full sm:w-1/2 md:w-full">
                                <div className="widget w-full p-16">
                                    <RankingWidget data={widgetDecorator({widget: Object.assign({},widgets.rankingWidget), type: 'vipRanking', array: rankingData.vipRanking})} title={'累積消費點數最多的會員'} column1Name={'累積扣點'} column2Name={'累積次數'}/>
                                </div>
                            </div>

                            <div className="mb-32 w-full sm:w-1/2 md:w-full">
                                <div className="widget w-full p-16">
                                    <RankingWidget data={widgetDecorator({widget: Object.assign({},widgets.rankingWidget), type: 'medicalRanking', array: rankingData.medicalRanking})} title={'累積獲得點數最多的合作夥伴'} column1Name={'累積加點'} column2Name={'累積次數'}/>
                                </div>
                            </div>

                        </div>
                        <div className="flex flex-wrap w-full md:w-320 pt-16">


                        </div>
                    </div>
                </FuseAnimate>
            </div>
        )
    };
}

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        getMonthlyData: Actions.getMonthlyData,
        getRankingData: Actions.getRankingData,
    }, dispatch);
}

function mapStateToProps({analyticsDashboardApp})
{
    return {
        monthlyData: analyticsDashboardApp.widgets.monthlyData,
        rankingData: analyticsDashboardApp.widgets.rankingData,
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AnalyticsDashboardApp));



// WEBPACK FOOTER //
// ./src/main/content/analytics/AnalyticsDashboardApp.js